export const crispWebsiteId = {
	stage: "7465de14-0f6f-45f5-b3ea-ea0ebe5e0bb4",
	live: "98336135-29f4-40b8-9f89-072acd027182",
};
